module.exports = __webpack_public_path__ + "static/media/morris-go-drive.6d3a9f53.png";